<template>
  <div class="mw-split-container mw-bar-data inner-view">
    <split-pane :defaultSize="216" split="vertical">
      <template slot="paneL">

      <mw-dialog ref="leadDialog" title="导出系统登录日志excel" size="mini_mini" :footerButton="leadButton">
       <div class="mw-dialog_body inner-toolbar__body" style="margin-top:20px;">
          <el-form label-width="100px">
            <el-col :span="24">
              <el-form-item label="开始时间">
                <template>
                  <el-date-picker
                    v-model="startDate"
                    type="datetime"
                    placeholder="选择时间"
                    :picker-options="pickerBeginDateBefore">
                  </el-date-picker>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="结束时间">
                <template>
                    <el-date-picker
                    v-model="finishDate"
                    type="datetime"
                    placeholder="选择时间"
                    :picker-options="pickerBeginDateAfter">
                  </el-date-picker>
                </template>
              </el-form-item>
            </el-col>
          </el-form>
       </div>
      </mw-dialog>

       <mw-dialog ref="editDialog" title="查看信息" size="small_large">

        <div class="mw-toolbar">
          <el-button  type="primary" @click="closeDialog('editDialog')"><i class="fa fa-mail-reply "></i> 关闭</el-button>
        </div>
       <div class="mw-toolbar__body inner-toolbar__body">
          <el-form label-width="130px">
            <el-col :span="24">
              <el-form-item label="用户名 :">
                <template>
                  <el-input style="width:96%" v-model="form.loginId" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="24">
              <el-form-item label="名称 :">
                <template>
                  <el-input style="width:96%" v-model="form.userName" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

             <el-col :span="24">
              <el-form-item label="浏览器信息 :">
                <template>
                    <el-input style="width:96%" v-model="form.userAgent" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="登录时间 :">
                <template>
                    <el-input readonly v-model="form.createTime"></el-input>
                </template>
              </el-form-item>
            </el-col>


            <el-col :span="12">
              <el-form-item label="服务器地址 :">
                <template>
                    <el-input v-model="form.serverName" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="服务器端口 :">
                <template>
                    <el-input v-model="form.serverPort" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="客户端IP :">
                <template>
                    <el-input v-model="form.clientIP" readonly></el-input>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="网卡地址 :">
                <template>
                    <el-input readonly></el-input>
                </template>
              </el-form-item>
            </el-col>



          </el-form>
       </div>
      </mw-dialog>

        <div class="mw-split-left">

          <div class="mw-toolbar__body">
            <div class="mw-toolbar">
              <el-button @click="expand"><i class="fa fa-angle-double-down" v-if="!btnNotShowIcon"></i>展开</el-button>
              <el-button @click="closed"><i class="fa fa-angle-double-up" v-if="!btnNotShowIcon"></i>折叠</el-button>
            </div>

            <div class="mw-toolbar__body">
              <mw-tree :url="treeUrl" :async="false" :multiple="false"  :selectFirst="true" :defaultParams="params && params.requestParams"
                       :expandedFirst="true"   @changed="loadTableTree" ref="logTree">
              </mw-tree>
            </div>
          </div>

        </div>
      </template>
      <template slot="paneR">
        <div class="mw-split-right" >

           <toolbar-table :layout="layout" @rowExpanded="rowExpanded" :autoLoad="false"  ref="dataTable"></toolbar-table>

        </div>
      </template>
    </split-pane>

  </div>
</template>
<script>
import token from "@/common/utils/token";
export default {
  components: {

  },
  props: {
    params: {
      type: Object
    }
  },

  data() {
    let me = this;
    return {
      layout: [],
      headers: {},
      treeUrl: this.mwUrl("/api/business/listLoginTree"),
      selectNode: "",
      finishDate: '',
      startDate: '',
      btnNotShowIcon:(window.$Env && $Env.btnNotShowIcon),
      leadButton: [
        {
          label: "确定",
          func: this.leadSure
        }, {
          label: "取消",
          type: "default",
          func: this.closeLeadDialog
        }
      ],

      form:{

      },

      pickerBeginDateBefore:{
          disabledDate(time) {
            if(me.finishDate != ''){
              return time.getTime() > me.finishDate
            }
          }
        },

        pickerBeginDateAfter:{
          disabledDate(time) {
            return time.getTime() < me.startDate
          }
        },
    };
  },

  mounted() {
    let me = this;
    me.headers.Authorization = token.getToken();
    let defaultParams = [];
    if(me.params && me.params.requestParams){
      defaultParams = me.params.requestParams;
    }
    me.layout = [
      [
        {
          span: 0,
          type: "menu",
          label: "登录日志",
          api: "business.listLoginLog",
          singleSelect: true,
          defaultParams:defaultParams,
          showRowExpander:true,
          columns: [
            { prop: "org", label: "组织",tooltip:true,formatter:me.orgFormatter},
            { prop: "userName",label: "登录人",tooltip: true,width:'80'},
            { prop: "userLoginId",label: "登录人账号",tooltip: true,width:'120'},
            { prop: "lastLoginTime",label: "最后登录时间",tooltip: true,width:'160'},
            { prop: "accessType", label: "最后登录方式",tooltip:true,width:'120'},
            { prop: "loginTimes", label: "今日登录次数",tooltip:true,width:'120'},
            { prop: "userAgent", label: "在线",tooltip:true,formatter:me.statusFormatter,width:'60'},
          ]
        },
        {
          span: 10,
          type: "button",
          items: [
            {
              label: "导出",
              icon: me.btnNotShowIcon ? '' : "fa fa-plus-square",
              func: me.lead
            }
          ]
        },
        {
          span: 6,
          type: "searchText",
          name: "userName",
          tip:"登录人",
          offset: 8
        }
      ]
    ];
    if(this.params && this.params.isSaveQueryLog==true)
      me.saveQueryLog();
  },

  methods: {
    expand() {
      this.mwRef('logTree').openAll();
    },
    closed() {
      this.mwRef('logTree').closeAll();
    },
    rowExpanded(row,el){
      let me=this;
      let par = {userId:row.userId,date:row.createYearMonthDay};
      if(me.params && me.params.requestParams){
        if(me.params.requestParams.excludeClientIP) {
          par.excludeClientIP = me.params.requestParams.excludeClientIP;
        }
        if(me.params.requestParams.includeFail){
          par.loginId = row.userLoginId;
        }
      }
      PF.ajax("api/business/listUserLog",par).then((data) => {
        var html=`<table class="inner_table" width="100%">
        <tr>
          <th>登录时间</th>
          <th>登录方式</th>
          <th>登录IP</th>
          <th>浏览器类型</th>
          <th>状态</th>
        </tr>`
        if(data.result){
          data.result.forEach(v=>{
            html+= "<tr><td>"+v.createTime+"</td><td>"+v.accessType+"</td><td>"+v.clientIP+"</td><td>"+me.userAgentFormatter(row,undefined,v.userAgent)+"</td><td>"+me.typeFormatter(v,"",v.type)+"</td></tr>";
          })
        }
        html+=`</table>`
        $(el).html(html);
      });
    },

    loadTableTree(data) {
      this.selectNode = data.id;
      let params=_.assign({id:data.id},this.params && this.params.requestParams)
      this.mwRef("dataTable").refreshTableDefaultParams(params);
    },
    statusFormatter(v){
      if(v.status==1){
        return <span class='fa fa-eye' style="color:#238E23" title="在线"></span>
      }else{
        return <span class='fa fa-eye' style="color:#ccc" title="离线"></span>
      }
    },
    orgFormatter(v){
      var org = "";
      org = (v.unit?v.unit:"")+"-"+(v.department?v.department:"");
      if(!v.unit&&!v.department){
        org = "";
      }
      return org;
    },
    userAgentFormatter(data,c,userAgent){

    if (userAgent == null)return "";

    var start = userAgent.indexOf("(");
    userAgent = userAgent.substring(start, userAgent.length);
    let os = "Windows";
    let bit = "32位";
    let brower = "";
    if (userAgent.indexOf("Windows NT 5.0") != -1) {
        os = "Win2000";
    } else if (userAgent.indexOf("Windows NT 5.1") != -1 || userAgent.indexOf("Windows XP") != -1) {
        os = "WinXP";
    } else if (userAgent.indexOf("Windows NT 5.2") != -1) {
        os = "Win2003";
    } else if (userAgent.indexOf("Windows NT 6.0") != -1) {
        os = "Win2008";
    } else if (userAgent.indexOf("Windows NT 6.1") != -1) {
        os = "Win7";
    } else if (userAgent.indexOf("Windows NT 6.2") != -1) {
        os = "Win8";
        if (userAgent.indexOf("ARM;") != -1) {
            os = "WinRT";
        }
    } else if (userAgent.indexOf("Windows NT 6") != -1) {
        os = "WinVista";
    } else if (userAgent.indexOf("Linux") != -1) {
        os = "Linux";
    } else if (userAgent.indexOf("Mac") != -1) {
        os = "Mac";
    }
    if (userAgent.indexOf("WOW64") != -1 || userAgent.indexOf("_64") != -1 || userAgent.indexOf("X64") != -1 || userAgent.indexOf("x64") != -1) {
        bit = "64位";
    }

    if (userAgent.indexOf("MSIE") != -1) {
        brower = "IE";
        var start = userAgent.indexOf("MSIE");
        var end = userAgent.indexOf(";", start);
        brower = brower + userAgent.substring(start + 5, end);
    } else if (userAgent.indexOf("rv:") != -1 && userAgent.indexOf("Firefox") == -1) {
        brower = "IE";
        var start = userAgent.indexOf("rv:");
        var end = userAgent.indexOf(")", start);
        brower = brower + userAgent.substring(start + 3, end);
    } else if (userAgent.indexOf("Firefox") != -1) {
        brower = "Firefox";
        var start = userAgent.indexOf("Firefox/");
        brower = brower + userAgent.substring(start + "Firefox".length + 1, userAgent.length);
    } else if (userAgent.indexOf("Chrome") != -1) {
        brower = "Chrome";
        var start = userAgent.indexOf("Chrome/");
        var end = userAgent.indexOf(".", start);
        end = userAgent.indexOf(".", end + 1);
        brower = brower + userAgent.substring(start + "Chrome".length + 1, end);
    } else if (userAgent.indexOf("Safari") != -1) {

        brower = "Safari";
        var start = userAgent.indexOf("Version/");
        var end = userAgent.indexOf(" ", start);
        brower = brower + userAgent.substring(start + "Version".length + 1, end);
    }

     return brower
    },

    typeFormatter(data,c,v){
      if(v === -1){
        return '登录失败'
      }else if(v  === 1){
        if(data.loginId){
          return '登录验证'}
        else{
          return '切换单位'
        }
      }else if(v === 2){
        return '登录成功'
      }else{
        return  '退出'
      }
    },

    lead() {
      this.mwRef("leadDialog").show();
    },

    closeLeadDialog(){
       this.mwRef("leadDialog").hide();
    },

    closeEditDialog(){
      this.mwRef('editDialog').hide();
    },

    edit(row,index){
         this.mwApi.business.getLoginLog(row.id).then(res =>{
             this.mwRef('editDialog').show();
             this.form = res.result;
         })
    },

    closeDialog(a){
      this.mwRef(a).hide()
    },
    leadSure(){
      var me=this;
      if(!me.startDate && !me.finishDate){
        me.mwMsg("warning", '请选择开始时间或结束时间!');
        return;
      }
      var params={};
      if(me.startDate)
        params.startDate=new moment(me.startDate).format("YYYY-MM-DD HH:mm:ss");
      if(me.finishDate)
        params.finishDate=new moment(me.finishDate).format("YYYY-MM-DD HH:mm:ss");
      if(me.params && me.params.requestParams && me.params.requestParams.includeUsers)
        params.includeUsers = me.params.requestParams.includeUsers;
      if(me.params && me.params.requestParams && me.params.requestParams.excludeUsers)
        params.excludeUsers = me.params.requestParams.excludeUsers;
      if(me.params && me.params.requestParams && me.params.requestParams.threeMemberType)
        params.threeMemberType = me.params.requestParams.threeMemberType;
      if(me.params && me.params.requestParams && me.params.requestParams.notThreeMemberType)
        params.notThreeMemberType = me.params.requestParams.notThreeMemberType;
      if(me.params && me.params.requestParams && me.params.requestParams.excludeClientIP)
        params.excludeClientIP = me.params.requestParams.excludeClientIP;
      if(me.params && me.params.requestParams && me.params.requestParams.condition)
        param.condition = me.params.requestParams.condition;
      this.mwApi.business.expLoginLog(params);
      this.closeLeadDialog();
    }
    ,
    saveQueryLog() {
      var dataTable = this.mwRef("dataTable").mwRef("dataTable");
      var tableObj = this.mwRef("dataTable");
      tableObj.$on("dataLoaded", function (d) {
        var total = d ? d.length : 0;
        if (tableObj.isSearch) {
          var rm = "共查询到" + total + "条记录";
          var params = {
            flag: "列表查询",
            targetName: '日志管理-登陆注销日志',
            remark: rm,
            objType: '日志',
            target: '功能',
            eventType: '三员管理操作',
            zycd: "一般",
            result: rm
          };
          PF.invoke("sys-log-service.saveOprLog", params);
        }
      })
    }
  },
  watch: {}
};
</script>
<style scoped>
.el-input {
  width: calc(100% - 5px);
}
.el-tree-node__content .el-checkbox {
  display: none;
}

</style>



// WEBPACK FOOTER //
// src/modules/index/views/systemSet/log/loginLog.vue